export const ENGLISH_ABBREVIATION = 'en';

interface IHasLabel {
  label: string;
}

export const labelComparator = <T extends IHasLabel>(a: T, b: T): number => {
  return a.label.localeCompare(b.label, ENGLISH_ABBREVIATION, { sensitivity: 'base' });
};

interface IHasName {
  name: string;
}

export const nameComparator = <T extends IHasName>(a: T, b: T): number => {
  return a.name.localeCompare(b.name, ENGLISH_ABBREVIATION, { sensitivity: 'base' });
};
